import { createContext } from 'react';
export const SubmitButtonContext = /*#__PURE__*/createContext({});